export default "__VITE_ASSET__BSfGFPZt__"